import request from "@/utils/request";
// update mapConfig
export function updateMapConfig(mapConfig) {
  return request({
    url: "/system/map-key-update",
    method: "post",
    data: mapConfig,
  });
}
